import {
    AfterViewInit, Component, ContentChildren, EventEmitter,
    Input, OnInit, Output, QueryList, ViewEncapsulation
} from '@angular/core';

import { ITabsCollection } from './tabs.interface';

@Component({
    selector: 'mlp-ng-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss'],
    // tslint:disable-next-line:use-view-encapsulation
    encapsulation: ViewEncapsulation.None
})

export class TabsSharedComponent implements OnInit, AfterViewInit {
    @Input() tabs: ITabsCollection;
    @Input() changeTabManually: EventEmitter<number> = new EventEmitter();
    @Output() tabClicked = new EventEmitter<number>();
    @ContentChildren('tab') items: QueryList<any>;
    numberTabs: number;
    currentIndex: number;
    responsive: string;

    ngOnInit(): void {
        this.numberTabs = this.tabs.tabs.length - 1;
        this.responsive = this.tabs.responsive;
        this.tabs.tabs.map((val, i) => {
            if (val.active) this.currentIndex = i;
        });
        this.changeTabManually.subscribe(newTab => {
            this.changeTab(newTab);
        });
    }

    get getResponive(): string {
        return (this.responsive) ? this.responsive : '';
    }

    ngAfterViewInit(): void {
        this.showContent(true);
    }

    changeTab(data: string | number): void {
        this.tabs.tabs[this.currentIndex].active = false;

        if (data === 'next') {
            this.showNextTab();
        }

        if (data === 'prev') {
            this.showPrevTab();
        }

        if (typeof data === 'number') {
            this.currentIndex = data;
        }

        this.tabs.tabs[this.currentIndex].active = true;
        this.tabClicked.emit(this.currentIndex);
        this.showContent();
    }

    private showNextTab(): void {
        this.currentIndex = (this.currentIndex < this.numberTabs) ? this.currentIndex + 1 : 0;
    }

    private showPrevTab(): void {
        this.currentIndex = (this.currentIndex !== 0) ? this.currentIndex - 1 : this.numberTabs;
    }

    private showContent(init = false): void {
        this.items.map((item, i) => {
            if (init) item.nativeElement.classList.add('sg-tabs__content');
            if (this.responsive) item.nativeElement.classList.add(this.responsive);
            item.nativeElement.classList.remove('-active');
            if (this.currentIndex === i) item.nativeElement.classList.add('-active');
        });
    }
}
